import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc532b1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_list" }
const _hoisted_4 = {
  key: 0,
  class: "box_title"
}
const _hoisted_5 = { class: "box_sub" }
const _hoisted_6 = {
  key: 0,
  class: "box_title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (item.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(item.title) + " ", 1 /* TEXT */),
                (item.button)
                  ? (_openBlock(), _createBlock(_component_a_space, {
                      key: 0,
                      size: "small",
                      class: "box_button"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.button, (v) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (v.router)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "button_n_2",
                                  to: v.router
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(v.title), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                              : _createCommentVNode("v-if", true),
                            (v.href)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 1,
                                  type: "link",
                                  class: "button_n_2",
                                  href: v.href,
                                  target: "_blank"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(v.title), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"]))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sub, (v) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (v.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(v.title) + " ", 1 /* TEXT */),
                    (v.button)
                      ? (_openBlock(), _createBlock(_component_a_space, {
                          key: 0,
                          size: "small",
                          class: "box_button"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.button, (vv) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (vv.router)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "button_n_2",
                                      to: vv.router
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(vv.title), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                                  : _createCommentVNode("v-if", true),
                                (vv.href)
                                  ? (_openBlock(), _createBlock(_component_a_button, {
                                      key: 1,
                                      type: "link",
                                      class: "button_n_2",
                                      href: vv.href,
                                      target: "_blank"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(vv.title), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.content, (vv) => {
                    return (_openBlock(), _createBlock(_component_a_col, {
                      xs: 24,
                      md: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          href: vv.href,
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(vv.title), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}